<template>
<div>
        <div v-if="trackId && !noExpertsForTrack">
            <programDisplay v-bind:settingsPerm="settingsPerm" v-bind:trackId="trackId"></programDisplay>
        </div>

    <div class='my-5'>
        <div v-if="expertsLoading">
            <img class="hidden-md hidden-sm hidden-xs" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/Speaker_Placeholder_Desktop_v1.svg" alt="">
            <img class="hidden-lg hidden-sm hidden-xs" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/Speaker_Placeholder_Tablet_v1.svg" alt="">
            <img class="hidden-md hidden-lg" src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/Speaker_Placeholder_Mobile_v1.svg" alt="">
        </div>
        <div v-if="!expertsLoading && speakers && speakers.length">
            <h3 class="my-3 text-block mb-5">TRACK SPEAKERS</h3>
            <div class="d-flex flex-wrap">
                <div class="col-6 col-md-4 col-lg-3 mb-4" v-for="(aSpeaker, index) in speakers" :key="index">
                    <div v-if="aSpeaker && aSpeaker.slug">
                        <router-link :to="`/speaker/${aSpeaker.slug}`">
                            <div class="sands-image-colored-overlay-hover text-center">
                                <img class="box-border-radius" v-if="aSpeaker.avatarSquareSmall && aSpeaker.avatarSquareSmall.xxx && aSpeaker.avatarSquareSmall.xxx !== 'null'" :src="aSpeaker.avatarSquareSmall.xxx" alt="">
                                <img class="box-border-radius" v-else src="/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/avatarSquareLarge_xx_mustermann_max_ek_1558018462305.png" alt="">
                            </div>
                        </router-link>
                    </div>
                    <div class="text-center my-3 gdlr-speaker-item-content">
                        <h3 class="gdlr-skin-title gdlr-speaker-item-title">
                            <router-link v-if="aSpeaker.forename && aSpeaker.surname && aSpeaker.slug" :to="`/speaker/${aSpeaker.slug}`">{{aSpeaker.forename}}&nbsp;{{aSpeaker.surname}}</router-link>
                            <span v-if="aSpeaker.forename && aSpeaker.surname && !aSpeaker.slug">{{aSpeaker.forename}}&nbsp;{{aSpeaker.surname}}</span>
                        </h3>
                        <div v-if="aSpeaker.company" class="gdlr-speaker-item-position gdlr-info-font gdlr-skin-info">{{aSpeaker.company}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!expertsLoading && noExpertsForTrack">
            <h3 class="my-3 text-block mb-5">No Data found for this track</h3>
        </div>
    </div>

</div>
</template>

<script>
import {
    ApolloClient,
    InMemoryCache
} from '@apollo/client/core'
import {
    provideApolloClient,
    useQuery
} from "@vue/apollo-composable";
import CONCORD_QUERIES from "../services/concord_queries.js"
import {
    watch
} from 'vue'
import {
    useRoute
} from 'vue-router';
import programDisplay from '../components/program.vue'
import trackJsonData from '../services/trackJsonData.js'
export default {
    name: 'trackDetail',
    props: {
        settingsPerm: Object
    },
    components: {
        programDisplay,
    },
    data() {
        return {
            expertsLoading: true,
            speakers: false,
            widgetHtml: false,
            trackId: false,
            trackSlug: this.$route.params.slug,
            trackInfo: false,
            noExpertsForTrack: false,
        };
    },
    mounted() {
        window.scrollTo(0, 0);
    },
    setup() {
        const route = useRoute();
        return route;
    },
    beforeRouteUpdate(to, from, next) {
        this.loading = true;
        // Call the API query method when the URL changes
        if (to && to.params && to.params.slug) {
            this.trackSlug = to.params.slug;
            this.getFreshExpertData(to.params.slug);
        }
        next()
    },
    created() {
        this.emitter.emit('tracksRelatedSessions', false);
        if (this.settingsPerm && this.settingsPerm.callToAction) {
            this.widgetHtml = this.settingsPerm.callToAction;
        }
        if (this.$route && this.$route.params.slug) {
            this.getFreshExpertData(this.$route.params.slug);
        }

    },
    methods: {
        getFreshExpertData(trackSlug) {
            this.trackInfo = false;
            this.noExpertsForTrack = false;
            this.speakers = false;
            this.expertsLoading = true;
            if (trackSlug) {
                this.trackInfo = trackJsonData.getTrackRelatedData(trackSlug);
                if (this.trackInfo && this.trackInfo.svg && this.trackInfo.name) {
                    this.emitter.emit('infoFromChild', this.trackInfo);
                }
                const cache = new InMemoryCache();
                const apolloClient = new ApolloClient({
                    cache,
                    uri: this.settingsPerm.concordBackendURL,
                })
                provideApolloClient(apolloClient)
                let trackSlugQueryVar = {
                    conferenceBrandId: this.settingsPerm.brandId,
                    slug: trackSlug
                };
                const {
                    result
                } = useQuery(CONCORD_QUERIES.TRACK_BY_SLUG, trackSlugQueryVar, {
                    fetchPolicy: 'cache-first',
                });
                watch(result, value => {
                    if (value && value.tracks && value.tracks.Tracks && value.tracks.Tracks.length && value.tracks.Tracks[0] && value.tracks.Tracks[0]._id) {
                        this.trackId = value.tracks.Tracks[0]._id;
                        let variablesForExpertQuery = {
                            trackFilter: [this.trackId],
                            pagesize: 32,
                            page: 1,
                            conferenceSeriesId: this.settingsPerm.seriesId,
                        };
                        const {
                            result
                        } = useQuery(CONCORD_QUERIES.TRACK_EXPERT_QUERY, variablesForExpertQuery, {
                            fetchPolicy: 'cache-first',
                        });
                        watch(result, value => {
                            if (value && value.vueExperts && value.vueExperts.Experts && value.vueExperts.Experts.length) {
                                this.expertsLoading = false;
                                this.speakers = value.vueExperts.Experts;
                            } else {
                                this.noExpertsForTrack = true;
                                this.expertsLoading = false;
                            }
                        })

                    } else {
                        this.trackId = toString(Math.floor(Math.random() * (99995454515451 - 2121 + 1)) + 2121);
                        this.noExpertsForTrack = true;
                                this.expertsLoading = false;
                            }
                })
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.track-info-top {
    background-image: url(https://devm.io/wp-content/uploads/2023/02/JAX_NY23_Website_Background_Programm_Highlights_a.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 20px !important;
}

.gdlr-speaker-item-title {
    font-size: 15px;
    text-transform: none;
    font-weight: bold;
    letter-spacing: 2px;
    margin-bottom: 7px;
}
.gdlr-speaker-social img {
    height: 25px;
}

.gdlr-speaker-social:not(:first-of-type) {
    margin-left: 5px;
}
.sands-image-colored-overlay-hover img{
    height: 173px;
    width: 247px;
}
@media screen and (max-width: 992px) {
.sands-image-colored-overlay-hover img{
    height: 150px;
    width: 150px;
}
}
</style>
